export const DetailsComponentTabsData = [
  { tab: 'Related-Cities' },
  { tab: 'Related-Districts' },
  { tab: 'Related-Communities' },
  { tab: 'Related-SubCommunities' }
];
